import { applyFaviconFromSettings, type SettingsWithBrandingFavicon } from './applyFaviconFromSettings.ts';

const PUBLIC_SETTINGS_ENDPOINT = '/settings/public';

interface PublicSettingsPayload extends SettingsWithBrandingFavicon {
  [key: string]: unknown;
}

interface BootstrapOptions {
  signal?: AbortSignal;
}

function isAbortError(error: unknown): boolean {
  if (typeof DOMException !== 'undefined' && error instanceof DOMException) {
    return error.name === 'AbortError';
  }
  return error instanceof Error && error.name === 'AbortError';
}

export async function bootstrapFavicon(options: BootstrapOptions = {}): Promise<void> {
  try {
    const response = await fetch(PUBLIC_SETTINGS_ENDPOINT, {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      signal: options.signal,
    });

    if (!response.ok) {
      return;
    }

    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
      return;
    }

    const data = (await response.json()) as PublicSettingsPayload;
    applyFaviconFromSettings(data);
  } catch (error) {
    if (isAbortError(error)) {
      return;
    }
    if (import.meta.env?.DEV) {
      console.warn('[branding] Failed to bootstrap favicon from /settings/public', error);
    }
  }
}

void bootstrapFavicon();
